module.exports = __webpack_public_path__ + "images/feef798c3ae2f7bb45943db1dee0d07b.svg";